module.exports = __webpack_public_path__ + "static/media/03(1).544d38c9.jpg";